import * as PIXI from "pixi.js";
import { EnumEventBus, EventBus } from "../EventBus";
import addInteraction from "../lib/addButtonInteraction";


export default class AutoPlayButton extends PIXI.Container {
  private autoBtn!: PIXI.Sprite;
  private stopBtn!: PIXI.Sprite;
  private countLabel!: PIXI.Text;

  constructor() {
    super();
    this.buildUI();

    EventBus.on(EnumEventBus.setAutoplayGame, (v: boolean, count: number) => v ? this.start(count) : this.stop());
    EventBus.on(EnumEventBus.setAutoPlayCount, (count: number) => this.setCount(count));
  }
  private buildUI() {
    // 1) Toggle buttons (outside popup)
    this.autoBtn = this.createButton(PIXI.Assets.get("Autoplay_but"), () => EventBus.emit(EnumEventBus.setAutoplayPopup, true));
    this.stopBtn = this.createButton(PIXI.Assets.get("stop_autoplay_but"), () => EventBus.emit(EnumEventBus.setAutoplayGame, false));
    this.stopBtn.visible = false;
    
    this.countLabel = new PIXI.Text();
    this.countLabel.style = new PIXI.TextStyle({
      fill: 0x000000,
      fontSize: 26,
      fontWeight: "700",
      stroke: 0xffffff,
      align: "center",
    });
    this.countLabel.anchor.set(.5);
    this.countLabel.visible = false;
    this.addChild(this.countLabel);
  }

  private createButton(assets: PIXI.Texture, onHandleTapFunc: () => void) {
    const btn = new PIXI.Sprite(assets);
    btn.anchor.set(.5);
    btn.eventMode = "static"; 
    addInteraction(btn, onHandleTapFunc, false);
    return this.addChild(btn);
  }
  private start(count: number) {
    this.countLabel.text = count;
    this.autoBtn.visible = false;
    this.stopBtn.visible = true;
    this.countLabel.visible = true;
  }
  private stop() {
    this.countLabel.text = "";
    this.autoBtn.visible = true;
    this.stopBtn.visible = false;
    this.countLabel.visible = false;
  }
  setAutoBtnFilter = (filters: PIXI.Filter[]) => this.autoBtn.filters = filters;
  setCount = (count: number) => this.countLabel.text = count; 
}